import {
  locations,
  CollegeSearchFilters,
  SearchFilters,
  searchFilters,
  institutionType,
  carnegieSizeSetting,
  locales,
  enrollmentSize,
  specialty,
} from '@common-types';

import { AutocompleteOption, Option } from '@interfaces';

export interface LocationOption extends Option {
  [key: string]: Option[] | string;
  // eslint-disable-next-line
  states: Option[];
}

const locationsData = (locations as unknown as LocationOption[]).map(
  ({ label, value, states }): AutocompleteOption => ({
    label,
    value,
    additionData: states,
  }),
);

export const SCHOOL_FILTERS_DATA = {
  ...searchFilters,
  search: {
    title: 'search',
    fieldName: 'keywords' as keyof CollegeSearchFilters,
  },
  schoolsType: {
    title: 'school type',
    fieldNames: {
      carnegieSizeSetting: 'carnegieSizeSettings' as keyof CollegeSearchFilters,
      institutionType: 'institutionTypes' as keyof CollegeSearchFilters,
    },
    filters: {
      carnegieSizeSetting,
      institutionType,
    },
  },
  location: {
    title: 'location',
    fieldName: 'states' as keyof CollegeSearchFilters,
    filters: locationsData,
  },
  enrollmentSize: {
    title: 'enrollment size',
    fieldName: 'totalStudentsEnrolled' as keyof CollegeSearchFilters,
    filters: enrollmentSize as Option[],
  },
  averageCost: {
    title: 'average cost, per year',
    fieldName: 'cost' as keyof CollegeSearchFilters,
  },
  specialty: {
    title: 'specialty school',
    fieldName: 'specialty' as keyof SearchFilters,
    filters: specialty as Option[],
  },
  settings: {
    title: 'setting',
    fieldName: 'locales' as keyof CollegeSearchFilters,
    filters: locales,
  },
  savedFilters: {
    title: 'saved filters',
    fieldName: 'savedFilters',
  },
  hasScholarship: {
    title: 'Scholarships available',
    fieldName: 'hasScholarship' as keyof CollegeSearchFilters,
  },
};
